import { type CardLanding, cardLandingOnParagraphText, combinedCardLanding } from "@common/utils/redline/text/card-collisions";
import { WordTokenizer } from "@common/utils/redline/text/word-tokenizer";
import { carriesTableOperations, type RedlineTextProposal } from "@common/utils/redline/wire/redline-payload";

import type { LivePageSnapshot } from "../proposal-tracker/page-revisions";

export function documentLandingOfCard(textRedline: RedlineTextProposal | null, page: LivePageSnapshot): CardLanding | null {
  if (textRedline === null || !page.completed) return null;
  if (textRedline.insertions.length > 0 || carriesTableOperations(textRedline.tableChanges)) return null;
  const paragraphLandings = textRedline.paragraphs.flatMap((paragraph) => {
    if (paragraph.bookmark === null || WordTokenizer.readsTheSame(paragraph.textWhenProposed, paragraph.textProposed)) return [];
    const liveParagraph = page.paragraphs.get(paragraph.bookmark);
    if (liveParagraph === undefined) return [];
    return [cardLandingOnParagraphText(paragraph, liveParagraph.text)];
  });
  if (paragraphLandings.length === 0) return null;
  return combinedCardLanding(paragraphLandings);
}

export function documentAlreadyReadsAsProposed(textRedline: RedlineTextProposal | null, page: LivePageSnapshot): boolean {
  if (textRedline === null) return false;
  if (textRedline.insertions.length > 0 || carriesTableOperations(textRedline.tableChanges)) return false;
  if (textRedline.paragraphs.length === 0) return false;
  return textRedline.paragraphs.every((paragraph) => {
    if (paragraph.bookmark === null) return false;
    const liveParagraph = page.paragraphs.get(paragraph.bookmark);
    return liveParagraph !== undefined && WordTokenizer.readsTheSame(liveParagraph.text, paragraph.textProposed);
  });
}
